import { FormattedMessage } from 'react-intl'
import { object, string } from 'yup'

import messages from './messages'

export const partialFeatureSchema = object()
  .shape({
    otherName: string(),
    name: string()
      // @ts-expect-error
      .required(<FormattedMessage {...messages.titleRequiredMessage} />)
      // @ts-expect-error
      .min(2, <FormattedMessage {...messages.featureNameMin} />)
  })
  .required()
